"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TSeverity = void 0;
// Verbose levels for logging errors
var TSeverity;
(function (TSeverity) {
    TSeverity["DEBUG"] = "debug";
    TSeverity["INFO"] = "info";
    TSeverity["WARNING"] = "warning";
    TSeverity["ERROR"] = "error";
    TSeverity["FATAL"] = "fatal";
})(TSeverity = exports.TSeverity || (exports.TSeverity = {}));
//# sourceMappingURL=TSeverity.js.map